import React from 'react';
import { MODULE_DISPLAY_NAMES } from '../../../../services/noteTypeService';
import styles from './NoteTypes.module.css';

const NoteTypeStatistics = ({ statistics, loading }) => {
    if (loading) {
        return (
            <div className={styles.statisticsContainer}>
                <div className={styles.statisticsLoading}>
                    <div className={styles.spinner}></div>
                    <span>Loading statistics...</span>
                </div>
            </div>
        );
    }

    if (!statistics) {
        return null;
    }

    const moduleStats = [
        { key: 'clientServicesCount', label: MODULE_DISPLAY_NAMES.ClientServices, value: statistics.clientServicesCount },
        { key: 'billingCount', label: MODULE_DISPLAY_NAMES.Billing, value: statistics.billingCount },
        { key: 'sampleControlCount', label: MODULE_DISPLAY_NAMES.SampleControl, value: statistics.sampleControlCount },
        { key: 'laboratoryCount', label: MODULE_DISPLAY_NAMES.Laboratory, value: statistics.laboratoryCount },
        { key: 'qaCount', label: MODULE_DISPLAY_NAMES.QA, value: statistics.qaCount },
        { key: 'clientCount', label: MODULE_DISPLAY_NAMES.Client, value: statistics.clientCount }
    ];

    // Calculate total for percentage calculations
    const total = moduleStats.reduce((sum, stat) => sum + stat.value, 0);

    return (
        <div className={styles.statisticsContainer}>
            <div className={styles.statisticsHeader}>
                <h3>Module Statistics</h3>
                <p>Note types available per module</p>
            </div>
            
            <div className={styles.statisticsGrid}>
                {moduleStats.map((stat) => {
                    // Calculate the actual percentage of total
                    const percentage = total > 0 ? (stat.value / total) * 100 : 0;
                    
                    return (
                        <div key={stat.key} className={styles.statCard}>
                            <div className={styles.statHeader}>
                                <h4 className={styles.statLabel}>{stat.label}</h4>
                                <span className={styles.statValue}>{stat.value}</span>
                            </div>
                            
                            <div className={styles.statBar}>
                                <div 
                                    className={styles.statBarFill}
                                    style={{ width: `${percentage}%` }}
                                />
                            </div>
                            
                            <div className={styles.statFooter}>
                                <small className={styles.statPercentage}>
                                    {Math.round(percentage)}% of total
                                </small>
                            </div>
                        </div>
                    );
                })}
            </div>
            
            <div className={styles.statisticsSummary}>
                <div className={styles.summaryItem}>
                    <span className={styles.summaryLabel}>Total Note Types:</span>
                    <span className={styles.summaryValue}>{total}</span>
                </div>
                <div className={styles.summaryItem}>
                    <span className={styles.summaryLabel}>Most Used Module:</span>
                    <span className={styles.summaryValue}>
                        {total > 0 
                            ? moduleStats.reduce((max, stat) => 
                                stat.value > max.value ? stat : max
                              ).label
                            : 'None'
                        }
                    </span>
                </div>
            </div>
        </div>
    );
};

export default NoteTypeStatistics;
